/* v263 · Preço com cupom.
   Só para quem tem cupom: pelo link (?discount=), digitado no carrinho ou no
   checkout, ou de influenciadora. As regras vêm do metacampo onm.cupons
   (valor, percentual, mínimo e se soma com o Pix), guardadas por hash.
   Cupom que soma com o Pix: o preço no Pix já sai com o cupom, com o Pix
   anterior riscado e a etiqueta "com cupom X": ao lado do preço na ficha e
   embaixo do preço, alinhada à esquerda, nos cartões (mesmo desenho das
   etiquetas de % off). A conta tira o cupom antes do
   Pix, que dá o número mais alto das duas ordens possíveis: nunca promete
   mais do que o checkout entrega.
   Cupom que não soma com o Pix: só a ficha ganha uma linha com o preço no
   cartão. Produto abaixo do mínimo: só a ficha ganha a linha do mínimo.
   Sem faixa, sem cor nova: tudo no tom do preço. */
(function () {
  'use strict';
  var R = window.ONM_CUPONS || { h: {}, i: [] };
  var ativo = null;

  function brl(c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  function pixPct() { var o = window.ONM && window.ONM.preco; return (o && +o.pix) || 0; }

  function hash(code) {
    if (!window.crypto || !crypto.subtle || !window.TextEncoder) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(code)).then(function (b) {
      var a = new Uint8Array(b), s = '';
      for (var k = 0; k < a.length; k++) s += ('0' + a[k].toString(16)).slice(-2);
      return s.slice(0, 16);
    });
  }

  function doCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function doLink() {
    try {
      var o = JSON.parse(localStorage.getItem('onm_cupom') || 'null');
      if (o && o.c && Date.now() - o.t < 30 * 864e5) return o.c;
    } catch (e) {}
    return '';
  }

  function achaCodigo() {
    var reserva = function () { return doCookie() || doLink(); };
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var d = (c && c.discount_codes) || [];
        for (var k = 0; k < d.length; k++) { if (d[k] && d[k].code) return d[k].code; }
        return reserva();
      })
      .catch(reserva);
  }

  function linha(el, t) { el.textContent = t; el.hidden = false; }

  function um(el) {
    var r = ativo.r, cod = ativo.c;
    var p = parseInt(el.getAttribute('data-cupom-preco'), 10);
    if (!p) return;
    var pdp = el.hasAttribute('data-cupom-pdp');
    var box = el.parentElement;
    var min = Math.round(r.m * 100);
    var desc = r.t === 'p' ? Math.floor(p * r.n / 100) : Math.round(r.n * 100);
    var base = Math.max(0, p - desc);

    if (p < min) { if (pdp) linha(el, 'Com o cupom ' + cod + ' em compras a partir de ' + brl(min)); return; }
    if (!r.c) { if (pdp) linha(el, 'Com o cupom ' + cod + ': ' + brl(base) + ' no cartão'); return; }

    var pct = pixPct();
    var novo = Math.floor(base * (100 - pct) / 100);
    var alvo = pdp ? box : (box.querySelector('.pr__v') || box);
    var b = alvo.querySelector(':scope > b');
    if (!b) return;
    var temRisco = !!box.querySelector('.pr__de, s');
    if (!temRisco) {
      var s = document.createElement('s');
      s.className = 'cupom-de';
      s.textContent = b.textContent;
      if (pdp) b.before(s); else alvo.before(s);
    }
    b.textContent = brl(novo);
    var i = alvo.querySelector(':scope > .pr__pix');
    var tag = document.createElement('em');
    tag.textContent = 'com cupom ' + cod;
    if (pdp) { tag.className = 'cupom-tag'; (i || b).after(tag); }
    else { tag.className = 'cupom-tag cupom-tag--card'; alvo.after(tag); }
    box.classList.add('cupom-on');
  }

  function precos() {
    if (!ativo || !ativo.r) return;
    var els = document.querySelectorAll('[data-cupom-preco]:not([data-cupom-ok])');
    for (var k = 0; k < els.length; k++) { els[k].setAttribute('data-cupom-ok', ''); um(els[k]); }
  }

  function aplica() {
    document.documentElement.classList.add('tem-cupom');
    precos();
    new MutationObserver(function (ms) {
      for (var k = 0; k < ms.length; k++) { if (ms[k].addedNodes.length) { precos(); break; } }
    }).observe(document.body, { childList: true, subtree: true });
    document.dispatchEvent(new CustomEvent('onm:cupom'));
  }

  function inicia() {
    achaCodigo().then(function (c) {
      if (!c) return;
      c = String(c).trim().toUpperCase();
      hash(c).then(function (h) {
        if (R.i && R.i.indexOf(h) > -1) return;
        ativo = { c: c, r: (R.h && R.h[h]) || null };
        if (ativo.r) aplica();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia);
  else inicia();
})();
